import React, { Fragment, useState, useEffect } from "react";
import { Typography, Box, Button, makeStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";

import Breadcrumb from "../../../../Breadcrumb";
import sentierBackground from "../../../../../images/sentierBackground.jpg";

// Liste des imports des composants constituant le formulaire
import Step1 from "./Step1";
import UploadPhoto from "../../../../UploadPhoto";

import Geoloc from "../../../../Geoloc";
import FinalStep from "../../../FinalStep";
import Satisfaction from "../../../../Satisfaction";

import Theme, { useStyles } from "../../../../Theme.js";

// Structure de base du document à sauvegarder pour réponse au fomulaire
const baseResult = {
  section: "services",
  theme: "aire_covoit",
};

const AiresCovoit = () => {
  const history = useHistory();
  const classes = useStyles();
  /**
   * @Description Permet de de gérer la navigation en avant au sein du formulaire
   */
  const goForth = (okp) => {
    if (ok === true || okp === true) {
      if (etape < etapes.length - 1) {
        setEtape(etape + 1);
      } else {
        history.goBack();
      }
    } else {
      alert("Cette étape est obligatoire avant de continuer");
    }
  };
  // Etape actuelle dans le formulaire
  const [etape, setEtape] = useState(0);
  // Autorisation à avancer dans le formulaire
  const [ok, setOk] = useState(true);
  // Document à envoyer au serveur une fois le formulaire fini,
  // Modifié dans chaque sous-composants du formulaire
  const [result, setResult] = useState(baseResult);
  // Tableau contenant tous les composants à faire défiler pour le formulaire
  // SetResult : méthode pour incrémenter la réponse au formulaire
  // SetAuthorization : méthode pour valider le passage à l'étape suivante
  const etapes = [
    <Step1
      result={result}
      setResult={setResult}
      setAuthorization={setOk}
      goForth={goForth}
    />,
    <Satisfaction
      result={result}
      setResult={setResult}
      setAuthorization={setOk}
    />,
    <UploadPhoto
      result={result}
      setResult={setResult}
      setAuthorization={setOk}
    />,

    <Geoloc result={result} setResult={setResult} setAuthorization={setOk} />,
    <FinalStep result={result} />,
  ];

  return (
    <Fragment>
      <Breadcrumb size={8} current={etape + 3} />
      <Box className={classes.subHeader}>
        <Typography variant="h3" className={classes.subHeaderTitle}>
          Aires de covoiturage
        </Typography>
      </Box>
      {etapes[etape]}
      <Box className={"suivantprecedent " + classes.boxButton}>
        <Button
          className={classes.navButton}
          onClick={() =>
            etape > 0
              ? setEtape(etape - 1)
              : history.push("/observation/services/mobilite", "aire-covoit")
          }
        >
          <ArrowRightAltIcon style={{ transform: "rotate(0.5turn)" }} />
          Etape précédente
        </Button>
        <Button className={classes.navButton} onClick={goForth}>
          Etape suivante <ArrowRightAltIcon />
        </Button>
      </Box>
    </Fragment>
  );
};

export default AiresCovoit;
